var PathPointMode = {
    STRAIGHT: 0,
    SMOOTH: 1,
    ANGLE: 2,
    ARC: 3
};

module.exports = PathPointMode;

